<template>
  <div class="inner_box">
    <div class="left_box" :style="{width:leftWidth+'px',minWidth:leftWidth+'px'}">
      <div><span :class="['line_title', langClass]">{{ $t('effective.email') }}</span>
        <span class="txt" v-if="!route.query.searchType">
          {{
            $t('userinfo.edm.number', {number: userDataInformation?.edmTotalNum ? userDataInformation?.edmTotalNum : 0})
          }}
        </span>
        <span class="txt" v-else>
          {{
            $t('userinfo.edm.number', {number: edmTotalNum})
          }}
        </span>
      </div>
      <div style="display: flex;justify-content:flex-start"
           v-if="(isEnterpriseMainUser && route.query.searchType) || isNormalUser">
        <span :class="['line_title', langClass]">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('common.bh') }}</span>
        <span class="content_text">
          <ul style="list-style: none;width: max-content">
<!--            <li v-for="(item,index) in mailContainDataVoList" :key="item">-->
            <!--              <span>{{ $t("userinfo.edm.number", {number: item.containData ?? 0}) }}</span>-->
            <!--              <span>{{ item?.expireTime }}</span>-->
            <!--            </li>-->
            <li v-for="(item,index) in mailContainDataVoList" :key="item">
              <div>
                <span>{{ item.containData ?? 0 }} {{ $t('common.ph23') }}</span>
                <span style="margin: 0px 6px;">-</span>
                <span v-if="item.free">
                  {{ `${$t('common.mf')}` }}
                </span>
                <span v-else>
                  <span>{{ $t(productSortSwitch(item.productSort * 1)) }}</span>
                 <span>（{{
                     item.startTime ? toISODateTime(item.startTime) : $t('common.yjmf')
                   }}</span>
                  <span v-if="item.startTime || item.endTime"> ~ </span>
                  <span>{{
                      item.endTime ? toISODateTime(item.endTime) : ''
                    }}）</span>
                </span>
              </div>
            </li>
          </ul>
        </span>
      </div>
      <div><span
          :class="['line_title', langClass]">{{ $t('edm.use.text') }}</span>
        <span class="txt">
          {{
            $t('userinfo.edm.number', {number: useDetailNum})
          }}
        </span>
      </div>
      <div><span :class="['line_title', langClass]">{{ $t('edm.available.number') }}</span>
        <span class="txt" v-if="!route.query.searchType">
          {{
            $t('userinfo.edm.number', {number: userDataInformation?.freeEdmNum || 0 ? userDataInformation?.freeEdmNum || 0 : 0})
          }}
        </span>
        <span class="txt" v-else>
          {{
            $t('userinfo.edm.number', {number: freeEdmNum})
          }}
        </span>
      </div>
    </div>
    <div class="right_box">
      <el-table
          :data="tableData"
          style="width: 100%"
          v-loading="loading"
          :header-cell-style="{'text-align': 'left', fontSize:'14px',color:'color: rgba(0,0,0,.85);', fontWeight: '500',background: '#f9f9f9', color: 'black', padding: '8px 0px'}"
      >
        <el-table-column prop="useTime" :label="$t('common.time.use')" width="auto"/>
        <el-table-column prop="userName" :label="$t('userinfo.edm.detail')" width="auto"/>
        <el-table-column prop="taskCode" :label="$t('sending.customer.search.no')"/>
        <el-table-column prop="teamName" :label="$t('common.sstd')"/>
        <el-table-column prop="useNum" :label="$t('userinfo.edm.user.number')">
        </el-table-column>
      </el-table>
      <div class="pages">
        <el-pagination
            size="small"
            v-model:current-page="current"
            v-model:page-size="size"
            background
            v-if="totals"
            layout="total, prev, pager, next, jumper"
            :total="totals"
            @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>
<script setup>
import {spaceSizeFormat} from "@/utils/file";
import {computed, onMounted, ref} from "vue";
import {useStore} from "vuex";
import {getAIList, getEDMList} from "@/api/usercenter";
import {ElMessage} from "element-plus";
import {getCompanyAccountDataDetail, getPersonAndCompanyInfoDataDetail} from "@/api/cloud";
import {useRoute} from "vue-router";
import {productSortSwitch} from "@/utils/util";
import dayjs from "dayjs";
import {toISODateTime} from "@/views/Home/utils";

const store = useStore()

const {leftWidth} = defineProps({
  leftWidth: {
    type: Number,
    default: 450,
  }
})
/**
 * 文件存储的空间大小
 */
const isNormalUser = computed(() => store.getters["user/isNormalUser"])
const isEnterpriseMainUser = computed(() => store.getters['user/isEnterpriseMainUser'])
const isEnterpriseChildUser = computed(() => store.getters['user/isEnterpriseChildUser'])
const userDataInformation = computed(() => store.state.cloud.userDataInformation)
const spaceSize = computed(() => store.state.cloud.spaceSize)
const tableData = ref([])
const loading = ref(false)
const route = useRoute()
// 分页
const current = ref(1);
const size = ref(10);
const totals = ref(0)
const handleCurrentChange = async (page) => {
  current.value = page;
  if (!route.query.searchType || isNormalUser.value) {
    await getTableEDMList()
  } else {
    await getPersonAndCompanyInfoDataDetailApis()
  }
};


const mailContainDataVoList = ref([])
const freeEdmNum = ref(0)
const edmTotalNum = ref(0)
const useDetailNum = ref(0)


// const edmTotalNumMain = ref(0)
const getTableEDMList = async () => {
  const payload = {
    pageSize: size.value,
    pageNo: current.value,
    type: 2,
  }
  try {
    loading.value = true
    const res = await getCompanyAccountDataDetail(payload)
    if (res.code !== 200) {
      ElMessage.error(res.message)
      return;
    }
    loading.value = false;
    const {useDetailData} = res.result
    mailContainDataVoList.value = res.result.mailContainDataVoList;
    tableData.value = useDetailData.records;
    current.value = useDetailData.current;
    totals.value = useDetailData.total;
    freeEdmNum.value = res.result.freeEdmNum;
    edmTotalNum.value = res.result.edmTotalNum;
    useDetailNum.value = res.result.useDetailNum
  } catch (e) {
    loading.value = false;
  }
}
// 企业主账号详情
const getPersonAndCompanyInfoDataDetailApis = async () => {
  const payload = {
    pageSize: size.value,
    pageNo: current.value,
    type: 2,
  }
  if (route.query.searchType) {
    payload.searchType = route.query.searchType * 1
  } else {
    if (isEnterpriseMainUser.value || isNormalUser.value) {
      payload.searchType = 2
    } else if (isEnterpriseChildUser.value) {
      payload.searchType = 1
    }
  }
  const res = await getPersonAndCompanyInfoDataDetail(payload)
  if (res.code !== 200) {
    ElMessage.error(res.message)
    return;
  }
  mailContainDataVoList.value = res.result.mailContainDataVoList;
  tableData.value = res.result.useDetailData.records;
  current.value = res.result.useDetailData.current;
  totals.value = res.result.useDetailData.total;
  freeEdmNum.value = res.result.freeEdmNum;
  edmTotalNum.value = res.result.edmTotalNum;
  useDetailNum.value = res.result.useDetailNum;
}

onMounted(async () => {
  if (!route.query.searchType || isNormalUser.value) {
    await getTableEDMList()
  } else {
    await getPersonAndCompanyInfoDataDetailApis()
  }
})


const lang = computed(() => store.state.system.langLocal)
const langClass = computed(() => {
  return lang.value !== 'zh-CN' ? 'lang-en' : 'lang-zh'
})
</script>

<style lang="less" scoped>
.inners {
  width: auto !important;
  max-width: 1200px !important;
  position: relative;
}

.right {
  height: auto !important;
  min-height: 640px !important;
  padding-bottom: 70px !important;
}

.inner_box {
  width: 100% !important;
  display: flex;
  flex-direction: column;
  //justify-content: flex-start;
  //align-items: flex-start;

  .left_box {
    width: auto;

    div {
      margin-bottom: 10px;
    }
  }

  .right_box {
    margin-top: 15px;
    width: 100%;
    flex: 1 1;
  }

}

.line_title {
  display: inline-block;
  width: max-content;
  min-width: 80px;
  color: #999;
  font-size: 14px;
}

.line_title.lang-zh {
  min-width: 80px;
}

.line_title.lang-en {
  text-align: right;
  min-width: 120px;
}

.txt {
  display: inline-block;
  color: #333;
  font-size: 14px;
  margin-left: 10px;
}

.results {
  width: 100%;
  border-top: 1px solid #e8e8e8;
  height: 53px;
  bottom: 0px;
  left: 0px;
  position: absolute;
  display: flex;
  justify-content: space-between;

  .buttons_pays {
    padding: 0 35px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    background: #d93737;
    margin-left: auto;
    cursor: pointer;
  }
}

.content_text {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  width: max-content;
  color: #999999;
  margin-left: 10px;
}

.pages {
  display: flex;
  justify-content: flex-end;
}
</style>